module.exports = __webpack_public_path__ + "media/stylesheets/images/icons/q-1393f402e56bc8d981bc1dd22823359a.svg";